module.exports = __webpack_public_path__ + "static/media/manageclass.cd07938c.png";